import { t } from "@/i18n-js/instance";
import incompleteIcon from "./Incomplete.svg";
import completeIcon from "./complete.svg";

interface StepIconProps {
  status: "complete" | "incomplete";
}

const localeRoot = "community_onboarding.new_checklist.setup_checklist";

export const StepIcon = ({ status }: StepIconProps) => {
  const isComplete = status === "complete";
  const icon = isComplete ? completeIcon : incompleteIcon;
  const alt = isComplete
    ? `${localeRoot}.complete_icon`
    : `${localeRoot}.incomplete_icon`;

  return (
    <img
      src={icon}
      alt={t(alt)}
      loading="lazy"
      className={`${isComplete ? "size-6" : "size-5"}`}
    />
  );
};
